import type { ScanScopeParams } from './hooks/useScanScopeParams';

export const DISCOVERABILITY_EXPORT_ROUTE = '/export-ai-insights-discoverability';

export type DiscoverabilityExportScope = {
  dateFrom: string;
  dateTo: string;
  crawlers: string[] | undefined;
  domain: string | undefined;
  scanScope: ScanScopeParams;
};

/**
 * Builds the export tab's URL from the filter state active at click time.
 *
 * The export page re-reads these params through the same hooks the tab uses, so
 * the PDF reflects exactly what was on screen. The scan-scope carriers ride
 * along for the same reason `handleInspectPages` writes them: a deep link from
 * the status banner pins the view to the window the daily scan counted, and an
 * export taken from that view must cover the same window rather than silently
 * widening to the plain calendar range.
 */
export function buildDiscoverabilityExportUrl({
  dateFrom,
  dateTo,
  crawlers,
  domain,
  scanScope,
}: DiscoverabilityExportScope): string {
  const params = new URLSearchParams({ dateFrom, dateTo });

  if (domain) params.set('domain', domain);
  // An empty list means "all crawlers" — the same absent-parameter convention
  // the filter row writes, so never emit `crawlers=`.
  if (crawlers && crawlers.length > 0) params.set('crawlers', crawlers.join(','));

  if (scanScope.dateTimeFrom) params.set('dateTimeFrom', scanScope.dateTimeFrom);
  if (scanScope.dateTimeTo) params.set('dateTimeTo', scanScope.dateTimeTo);
  if (scanScope.domains && scanScope.domains.length > 0) {
    params.set('domains', scanScope.domains.join(','));
  }

  return `${DISCOVERABILITY_EXPORT_ROUTE}?${params.toString()}`;
}
